import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const isAuthenticated = localStorage.getItem('token'); // Check if token exists

    return isAuthenticated ? (
        <Component {...rest} />
    ) : (
        <Navigate to="/login" /> // Use Navigate instead of Redirect
    );
};

export default ProtectedRoute;
